// extracted by css-extract-rspack-plugin
export default {"labelDotsContainer":"LabelDots-module__labelDotsContainer__vCyCs","labelDot":"LabelDots-module__labelDot__qtvam"};